import moment from "moment";

const state = {
  schedule: null,
  nextClass: {
    classId: "-",
    time: "-"
  },
};

const mutations = {
  SET_SCHEDULE(state, schedule) {
    state.schedule = schedule;
  },
  SET_SCHEDULE_TRIGGERED(state, data) {
    const idx = state.schedule[data.week][data.day]
      .findIndex(item => item.time === data.scheduledClassToSetTriggered.time);
    data.scheduledClassToSetTriggered.triggered = true;
    state.schedule[data.week][data.day].splice(idx, 1, data.scheduledClassToSetTriggered);
  },
  SET_NEXT_CLASS(state, nextClass) {
    state.nextClass = nextClass;
  }
};

const actions = {

  downloadSchedule({ commit, rootState }, schedule) {

    const year = moment().isoWeekYear();

    rootState.Database.db.collection("schedules").doc(schedule).collection("schedule").doc(year.toString())
      .onSnapshot({
        // Listen for document metadata changes
        includeMetadataChanges: true
      }, doc => {
        commit("SET_SCHEDULE", doc.data());
      });
  },
  setScheduleTriggered({ commit, rootGetters }, data) {
    commit("SET_SCHEDULE_TRIGGERED", {
      scheduledClassToSetTriggered: data,
      week: rootGetters.getDayAndWeek.week,
      day: rootGetters.getDayAndWeek.day
    });
  },
  setNextClass({ commit, rootGetters }) {
    if (state.schedule && state.schedule[rootGetters.getDayAndWeek.week] &&
      state.schedule[rootGetters.getDayAndWeek.week][rootGetters.getDayAndWeek.day] && 
      state.schedule[rootGetters.getDayAndWeek.week][rootGetters.getDayAndWeek.day].length > 0) {

      /* let previousClassTime = null; */
      let nextClass = null;

      if (state.schedule[rootGetters.getDayAndWeek.week][rootGetters.getDayAndWeek.day].length > 0) {
        state.schedule[rootGetters.getDayAndWeek.week][rootGetters.getDayAndWeek.day].forEach(element => {

          const elementTime = moment(element.time, "HH:mm");
          if (nextClass === null && elementTime > moment()) {
            nextClass = element;
          } else if (nextClass !== null && elementTime > moment() && elementTime < moment(nextClass.time, "HH:mm") &&
            (element.triggered === undefined || element.triggered === false)) {
            nextClass = element;
            /* previousClassTime = moment(element.time, "HH:mm") */
          }

        });
        if (nextClass !== null) {
          commit("SET_NEXT_CLASS", nextClass);
        } else {
          commit("SET_NEXT_CLASS", {
            name: "-",
            classId: "-",
            time: "-"
          });
        }
      }
    } else {
      commit("SET_NEXT_CLASS", {
        name: "-",
        classId: "-",
        time: "-"
      });
    }
  },
  checkScheduleForTrigger({ getters, rootGetters, dispatch }) {

    return new Promise(resolve => {
      const now = moment();
      const foundScheduledClass = getters.getCurrentDaySchedule.find(scheduledClass => {
        const video = rootGetters.getVideos.find(v => v.id === scheduledClass.classId);
        if (scheduledClass.triggered) return false;
        if (!video || !video.enabled) return false;
        const b = moment(scheduledClass.time, "HH:mm");
        let t = 30;
        if (
          rootGetters.getDisplayDriver !== undefined &&
          rootGetters.getDisplayDriver !== null &&
          rootGetters.getDisplayDriver.onTime !== undefined
        ) {
          t = rootGetters.getDisplayDriver.onTime;
        }
        if (b.diff(now, "seconds") < t && b.diff(now, "seconds") > 0) {
          dispatch("setScheduleTriggered", scheduledClass);
          return true;
        } 
        return false;
        
      });

      if (foundScheduledClass !== undefined) {
        resolve(foundScheduledClass);
      } else {
        resolve(false);
      }
    });
  },
};

const getters = {
  getSchedule(state, rootGetters) {
    if (state.schedule && state.schedule[rootGetters.getDayAndWeek.week]) {
      const days = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
      for (let i = 0; i < days.length; i++) {
        if (state.schedule[rootGetters.getDayAndWeek.week][days[i]] &&
          state.schedule[rootGetters.getDayAndWeek.week][days[i]].length > 1) {
          state.schedule[rootGetters.getDayAndWeek.week][days[i]]
            .sort((a, b) => {
              if (a.time < b.time) return -1;
              if (a.time > b.time) return 1;
              return 0;
            });
        }
      }
      return state.schedule[rootGetters.getDayAndWeek.week];
    }
    
    return [];
    
  },
  getCurrentDaySchedule(state, rootGetters) {

    if (state.schedule && state.schedule[rootGetters.getDayAndWeek.week] &&
      state.schedule[rootGetters.getDayAndWeek.week][rootGetters.getDayAndWeek.day]) {
      return state.schedule[rootGetters.getDayAndWeek.week][rootGetters.getDayAndWeek.day];
    }
    
    return [];
    
  },
  getClassesToday(state, rootGetters) {

    if (state.schedule && state.schedule[rootGetters.getDayAndWeek.week] &&
      state.schedule[rootGetters.getDayAndWeek.week][rootGetters.getDayAndWeek.day]) {
      return state.schedule[rootGetters.getDayAndWeek.week][rootGetters.getDayAndWeek.day].length;
    }
    
    return 0;
    
  },
  getNextClass(state) {
    return state.nextClass;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}; 



// WEBPACK FOOTER //
// ./src/store/modules/Schedule.js